import React from 'react';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import PipelineItem from './PipelineItem';
import { metricNames } from '@linearb/linjs-common';

const PipelineBlockEdge = styled(Flex)`
  min-width: 10rem;
  height: 0.8rem;
  ${({ start }) =>
    start
      ? `background: linear-gradient(270deg, #B1BDD6 -0.44%, rgba(177, 189, 214, 0) 95.56%);`
      : `background: linear-gradient(90deg, #B1BDD6 0%, rgba(177, 189, 214, 0) 85.03%);
     transform: skewX(35deg);
    `};
`;
const DeploymentPipeline = ({
  configurations = [],
  withEdges,
  enableDescription = true,
  isHideNonWorkingDaysEnabled,
  includedStages = null
}) =>
  configurations.length ? (
    <Flex width='100%'>
      {withEdges && <PipelineBlockEdge start='true' mr='tiny' />}
      {configurations.map((config, idx) => (
        <PipelineItem
          key={config.rightTag + idx}
          enableDescription={enableDescription}
          valueSize={withEdges ? 'x-x-large' : 'large'}
          titleSpace={withEdges ? 'x-big' : 'big'}
          isFirst={idx === 0}
          isHideNonWorkingDaysEnabled={isHideNonWorkingDaysEnabled}
          {...config}
          isIncludedStage={(
            includedStages || [
              metricNames.TIME_TO_PR,
              metricNames.TIME_TO_REVIEW,
              metricNames.REVIEW_TIME,
              metricNames.TIME_TO_PROD
            ]
          ).includes(config.metricName)}
        />
      ))}
      {withEdges && <PipelineBlockEdge />}
    </Flex>
  ) : null;

export default DeploymentPipeline;
